<template>
  <div v-if="visible">
    <a-spin
      :spinning="spinning"
      tip="提交作业..."
    >
      <div
        :style="{margin: '0px 200px 15px', paddingTop: '20px',fontSize: '20px',color: 'white'}"
        v-if="count > 0"
      >
        <p>
          剩余<b :style="{fontSize: '50px'}"> {{ count }} </b>道题
        </p>
        <p :style="{color: 'white'}">
          就可以完成该作业了，加油
        </p>
      </div>
      <div
        :style="{margin: '0px 200px 15px', paddingTop: '20px',fontSize: '20px',color: 'white'}"
        v-else
      >
        <p :style="{fontSize: '25px'}">
          恭喜完成了全部题目
        </p>
        <p :style="{color: 'white'}">
          请确认后提交作业！
        </p>
      </div>
      <div
        class="innerbox"
        :style="{borderRadius: '5px',height:'430px',margin: '30px 30px 0px',backgroundColor: 'white',color:'black',overflow:'auto'}"
      >
        <div
          v-for="(item,index) in value"
          :key="index"
          :style="{paddingTop: '15px', paddingLeft: '30px',paddingRight:'30px'}"
        >
          <a-row :gutter="48">
            <a-col :span="24">
              <div :style="{height:'40px',lineHeight:'40px',borderRadius: '5px'}">
                <a-divider
                  type="vertical"
                  :style="{width: '5px',height: '15px',backgroundColor: '#1890ff'}"
                />
                <b :style="{margin: '10px'}">{{ item .title }}（{{ item.totalScore }}.0 分）</b>
              </div>
            </a-col>
          </a-row>
          <div
            :style="{height:'40px',lineHeight:'40px',borderRadius: '5px'}"
            v-if="item.type === '1'"
          >
            <a-row :gutter="48">
              <a-col
                style="padding-right: 40px;"
                :span="1"
                v-for="(items,index2) in item.option"
                :key="index2"
              >
                <div
                  v-if="items.result === ''"
                  class="answerCard"
                  @click="locationChange(item)"
                >{{ index2 + 1 }}</div>
                <div
                  v-else
                  class="answerCard"
                  style="backgroundColor: #bfbfbf"
                  @click="locationChange(item)"
                >{{ index2 + 1 }}</div>
              </a-col>
            </a-row>
          </div>
          <div
            :style="{height:'40px',lineHeight:'40px',borderRadius: '5px'}"
            v-if="item.type === '2'"
          >
            <a-row :gutter="48">
              <a-col
                style="padding-right: 40px;"
                :span="1"
                v-for="(items,index2) in item.option[0].choiceList"
                :key="index2"
              >
                <div
                  v-if="items.result === ''"
                  class="answerCard"
                  @click="locationChange(item)"
                >{{ index2 + 1 }}</div>
                <div
                  v-else
                  class="answerCard"
                  style="backgroundColor: #bfbfbf"
                  @click="locationChange(item)"
                >{{ index2 + 1 }}</div>
              </a-col>
            </a-row>
          </div>
          <div
            :style="{height:'40px',lineHeight:'40px',borderRadius: '5px'}"
            v-if="item.type === '3'"
          >
            <a-row :gutter="48">
              <a-col
                style="padding-right: 40px;"
                :span="1"
                v-for="(items,index2) in item.option[0].questionList"
                :key="index2"
              >
                <div
                  v-if="items.result === ''"
                  class="answerCard"
                  @click="locationChange(item)"
                >{{ index2 + 1 }}</div>
                <div
                  v-else
                  class="answerCard"
                  style="backgroundColor: #bfbfbf"
                  @click="locationChange(item)"
                >{{ index2 + 1 }}</div>
              </a-col>
            </a-row>
          </div>
          <div
            :style="{lineHeight:'40px',borderRadius: '5px'}"
            v-if="item.type === '4'"
          >
            <a-row
              :gutter="48"
              v-for="(items,index2) in item.option"
              :key="index2"
            >
              <a-col
                :style="{marginLeft: '10px'}"
                :span="23"
                v-if="item.option.length > 1"
              >第 {{ index2 + 1 }} 部分</a-col>
              <a-col
                style="padding-right: 40px;"
                :span="1"
                v-for="(item2,index3) in items.questionList"
                :key="index3"
              >
                <div
                  v-if="item2.result === ''"
                  class="answerCard"
                  @click="locationChange(item)"
                >{{ index3 + 1 }}</div>
                <div
                  v-else
                  class="answerCard"
                  style="backgroundColor: #bfbfbf"
                  @click="locationChange(item)"
                >{{ index3 + 1 }}</div>
              </a-col>
            </a-row>
          </div>
          <div
            :style="{height:'40px',lineHeight:'40px',borderRadius: '5px'}"
            v-if="item.type === '5'"
          >
            <a-row
              :gutter="48"
              v-for="(item4,index4) in item.option"
              :key="index4"
            >
              <a-col
                :style="{marginLeft: '10px'}"
                :span="23"
                v-if="item.option.length > 1"
              >第 {{ index4 + 1 }} 部分</a-col>
              <a-col
                style="padding-right: 40px;"
                :span="1"
                v-for="(items,index2) in item4.choiceList"
                :key="index2"
              >
                <div
                  v-if="items.result === ''"
                  class="answerCard"
                  @click="locationChange(item)"
                >{{ index2 + 1 }}</div>
                <div
                  v-else
                  class="answerCard"
                  style="backgroundColor: #bfbfbf"
                  @click="locationChange(item)"
                >{{ index2 + 1 }}</div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div :style="{textAlign:'center',marginTop:'40px'}">
        <a-button
          type="primary"
          :style="{width: '15%',backgroundColor:'#339999'}"
          @click="onClose"
        >返回作业</a-button>
        <a-button
          type="primary"
          @click="submitExam"
          :style="{width: '15%',marginLeft:'20px',backgroundColor:'#339999'}"
        >完成作业</a-button>
      </div>
    </a-spin>
  </div>
</template>
<script>
import { addScore, delBatchRecord, addHistoryList } from '@/api/task/taskDetails'
import { mapGetters } from 'vuex'

export default {
  name: 'AnswerForm',
  components: {
    mapGetters
  },
  computed: {
    ...mapGetters(['studentId'])
  },
  data () {
    return {
      spinning: false,
      dataList: [],
      recordList: [],
      visible: false,
      count: 0,
      taskForm: {},
      examForm: {},
      totalScore: 0.0,
      score: 0.0,
      queryParam: {}
    }
  },
  created () {
    // this.dataForm = this.value
  },
  methods: {
    handleOpen (item, value) {
      this.totalScore = 0
      this.score = 0
      // console.log('value:' + JSON.stringify(value))
      this.examForm = item
      this.value = value
      this.visible = true
      this.onChangeCount(value)
    },
    // 返回练习
    onClose () {
      this.visible = false
      this.$emit('returnChange')
    },
    // 点击定位题目
    locationChange (item) {
      this.visible = false
      this.$emit('locationChange', item)
    },
    // 交卷
    submitExam () {
      this.$confirm({
        title: '确认完成作业，并提交?',
        okText: '提交',
        cancelText: '取消',
        okButtonProps: {
          on: {
            click: this.clickHandler
          }
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    },
    // 确认交卷
    clickHandler () {
      this.spinning = true
      this.value.forEach((item, i) => {
        if (item.type === '1') {
          const data = item.option
          data.forEach((items, i) => {
            this.recordList.push({
              homeworkId: this.examForm.id,
              questionId: items.questionId,
              score: JSON.stringify(items)
            })
          })
        }
        if (item.type === '2') {
          const data = item.option[0]
          var reg = new RegExp('<input type="text" class="ant-input" style="width:110px;color: #1890ff;border-color: #1890ff; font-size: 17px"/>', 'g')
          data.title = data.title.replace(reg, '_')
          this.recordList.push({
            homeworkId: this.examForm.id,
            questionId: item.questionId,
            score: JSON.stringify(data)
          })
        }
        if (item.type === '3') {
          const data = item.option[0]
          var reg2 = new RegExp('<input type="text" disabled class="ant-input" style="width:110px;color: #1890ff;border-color: #1890ff; font-size: 17px"/>', 'g')
          data.title = data.title.replace(reg2, '_')
          this.recordList.push({
            homeworkId: this.examForm.id,
            questionId: item.questionId,
            score: JSON.stringify(data)
          })
        }
        if (item.type === '4') {
          const data = item.option
          data.forEach((items, i) => {
            this.recordList.push({
              homeworkId: this.examForm.id,
              questionId: items.questionId,
              score: JSON.stringify(items)
            })
          })
        }
        if (item.type === '5') {
          const data = item.option
          data.forEach((item0, i) => {
            this.recordList.push({
              homeworkId: this.examForm.id,
              questionId: item0.questionId,
              score: JSON.stringify(item0)
            })
          })
        }
      })
      // console.log('recordList:' + JSON.stringify(this.recordList))
      // 保存成绩
      this.handleExamScore()
    },
    // 保存成绩
    handleExamScore () {
      this.taskForm.examPaperId = this.examForm.id
      this.taskForm.totalScore = this.handleTotalScore(this.value)
      this.taskForm.score = this.rightTotalScore(this.value)
      addScore(Object.assign(this.taskForm)).then(res => {
        this.$message.success('提交作业成功!')
        // 保存做题历史
        this.handleHistory()
      }).catch(() => {
        this.$message.error('提交作业失败')
      }).finally(() => {
        this.spinning = false
        this.$emit('onClose')
      })
    },
    // 保存做题历史
    handleHistory () {
      this.removeRecord()
      if (this.recordList.length > 0) {
        // console.log('recordList:' + JSON.stringify(this.recordList))
        addHistoryList(Object.assign(this.recordList))
      }
    },
    // 删除做题进度
    removeRecord () {
      console.log('删除做题进度')
      let ids = ''
      this.value.forEach((item, i) => {
        if (item.type === '1' || item.type === '4') {
          item.option.forEach((items, i) => {
            if (typeof (items.recordId) !== 'undefined') {
              ids = items.recordId + ',' + ids
            }
          })
        } else {
          if (item.recordId !== '') {
            ids = item.recordId + ',' + ids
          }
        }
      })
      console.log('ids: ' + ids)
      if (ids !== '') {
        delBatchRecord(ids)
      }
    },
    // 题数统计
    onChangeCount (value) {
      // console.log('value统计:' + JSON.stringify(value))
      let count = 0
      value.forEach((item, i) => {
        // 单选
        if (item.type === '1') {
          item.option.forEach((items, i) => {
            if (items.result === '') {
              count = count + 1
            }
          })
        }
        // // 语法填空
        if (item.type === '2') {
          item.option[0].choiceList.forEach((items, i) => {
            if (items.result === '') {
              count = count + 1
            }
          })
        }
        // 完形填空
        if (item.type === '3') {
          item.option[0].questionList.forEach((items, i) => {
            if (items.result === '') {
              count = count + 1
            }
          })
        }
        // 阅读理解 1
        if (item.type === '4') {
          item.option.forEach((items, i) => {
            items.questionList.forEach((data, i) => {
              if (data.result === '') {
                count = count + 1
              }
            })
          })
        }
        // 阅读理解 2
        if (item.type === '5') {
          item.option.forEach((item0, i) => {
            item0.choiceList.forEach((items, i) => {
              if (items.result === '') {
                count = count + 1
              }
            })
          })
        }
      })
      this.count = count
    },
    // 计算每题得分
    rightScore (value) {
      let index = 0
      if (value.type === '1') {
        value.option.forEach((item, i) => {
          if (item.result === item.answer && item.result !== '') {
            index += 1
          }
        })
      }
      if (value.type === '2') {
        value.option[0].choiceList.forEach((item, i) => {
          const answer = item.answer.replace(/[ ]/g, '').toLowerCase()
          const result = item.result.replace(/[ ]/g, '').toLowerCase()
          if (result === answer && result !== '') {
            index += 1
          }
        })
      }
      if (value.type === '3') {
        value.option[0].questionList.forEach((item, i) => {
          if (item.result === item.answer && item.result !== '') {
            index += 1
          }
        })
      }
      if (value.type === '4') {
        value.option.forEach((item, i) => {
          item.questionList.forEach((items, i) => {
            if (items.result === items.answer && items.result !== '') {
              index += 1
            }
          })
        })
      }
      if (value.type === '5') {
        value.option.forEach((item0, i) => {
          item0.choiceList.forEach((item, i) => {
            const answerList = item.answer.split('/')
            let num = 0
            answerList.forEach((items, i) => {
              // .toLowerCase()
              const answer = items.replace(/[ ]/g, '').toLowerCase()
              const result = item.result.replace(/[ ]/g, '').toLowerCase()
              if (answer === result && result !== '') {
                num += 1
              }
            })
            if (num > 0) {
              index += 1
            }
          })
        })
      }
      return index * parseInt(value.average)
    },
    // 计算总得分
    rightTotalScore (value) {
      let score = 0
      value.forEach((item, i) => {
        score += this.rightScore(item)
      })
      this.score = score
      return score
    },
    // 计算总分
    handleTotalScore (value) {
      let totalScore = 0
      value.forEach((item, i) => {
        totalScore += item.totalScore
      })
      this.totalScore = totalScore
      return totalScore
    }
  }
}
</script>
<style>
.answerCard {
  margin: 10px 10px;
  width: 35px;
  height: 35px;
  border: 2px solid #bfbfbf;
  border-radius: 100px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.answerCard:hover {
  background-color: #bfbfbf;
}
</style>
